<template>
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">Plan Name</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control has-icons-left">
                    <input class="input" type="text" v-model="name" placeholder="Plan Name" :class="{ 'is-danger': errors.name }">
                    <span class="icon is-left">
                    <i class="fas fa-signature"></i>
                </span>
                    <p v-if="errors.name" class="help is-danger">{{ errors.name[0] }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        computed: {
            name: {
                get() {
                    return this.$store.getters.getNewPricePlan.name
                },
                set(value) {
                    this.$store.dispatch('setNewPricePlanFieldValue', {field: 'name', value: value})
                }
            },
            errors() {
                return this.$store.getters.getNewPricePlanErrors
            }
        },
        mounted () {

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/PricePlans/NewPlan/Inputs/NameInput.vue